import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { SvgIcon } from 'src/components/shared/SvgIcon'
import { SvgType } from 'src/components/shared/SvgIcon/SvgIcon'
import { toggleMute } from 'src/ducks/layout'
import routes from 'src/routes'
import styled from 'styled-components'
import { logoutUser } from '../../ducks/auth'
import { COLORS } from '../../styles/theme'
import Amplitude from '../../utils/amplitudeHelper'

const MobileMenu = ({ currentUser }) => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { muted } = useSelector((state) => state.layout)

  const handleRedirect = (url) => {
    history.push(url)
  }

  const goBack = () => {
    history.goBack()
  }

  const handleLogout = () => {
    Amplitude.clickLogout()
    logoutUser(dispatch, currentUser, location.pathname, 'You have logged out')
  }

  const toggleAudio = () => {
    Amplitude.clickMute()
    dispatch(toggleMute())
  }

  return (
    <Page>
      <div className="outer-wrapper">
        <div className="container">
          <div className="title-container">
            <p className="title">Menu</p>
            <div className="back-button" onClick={goBack}>
              Back
            </div>
          </div>

          <div className="nav-btns">
            <div className="btn-container">
              <button onClick={() => handleRedirect(routes.auditorium1)}>Auditorium</button>
            </div>
            <div className="btn-container">
              <button onClick={() => handleRedirect(routes.onDemand)}>Gallery</button>
            </div>
            <div className="btn-container">
              <button onClick={handleLogout}>
                <span className="pr-2">Log Out </span>
                <svg className="logout-icon" width="20px" height="20px" viewBox="0 0 30.797 29.609">
                  <g transform="translate(0 0)">
                    <g>
                      <g>
                        <path
                          d="M311.743,156.064c.012-.014.022-.029.033-.044s.027-.035.039-.053.022-.036.033-.054.02-.033.029-.05.018-.037.027-.056.017-.035.025-.053.014-.037.02-.055.014-.039.021-.059.01-.037.014-.056.011-.04.015-.061.007-.044.01-.065.006-.036.008-.054a1.253,1.253,0,0,0,0-.243c0-.018-.005-.036-.008-.054s-.006-.044-.01-.065-.01-.041-.015-.061-.009-.038-.014-.056-.013-.039-.02-.059-.013-.037-.02-.055-.016-.036-.025-.053-.017-.038-.027-.056-.02-.033-.029-.05-.021-.036-.033-.054-.026-.035-.039-.053-.021-.03-.033-.044c-.026-.031-.053-.061-.081-.09h0l-3.7-3.7a1.234,1.234,0,1,0-1.745,1.745l1.6,1.6H300.92a1.234,1.234,0,1,0,0,2.467h6.891l-1.6,1.6a1.234,1.234,0,0,0,1.745,1.745l3.7-3.7h0Q311.7,156.111,311.743,156.064Z"
                          transform="translate(-281.225 -141.712)"
                          fill="#A31D20"
                        />
                        <path
                          d="M21.984,18.277a1.234,1.234,0,0,0-1.234,1.234v6.168H15.816V5.941h0a1.234,1.234,0,0,0-.879-1.182L10.651,3.473h10.1V9.642a1.234,1.234,0,0,0,2.467,0V2.24a1.234,1.234,0,0,0-1.234-1.234H2.245c-.036,0-.073,0-.108,0a1.182,1.182,0,0,0-1.069.859c-.009.028-.016.056-.023.084l0,.009q-.01.044-.017.089l0,.013c0,.028-.007.056-.009.084a1.32,1.32,0,0,0,0,.137V26.914A1.234,1.234,0,0,0,2,28.123L14.34,30.591a1.234,1.234,0,0,0,1.476-1.21V28.147h6.168a1.234,1.234,0,0,0,1.234-1.234v-7.4A1.234,1.234,0,0,0,21.984,18.277Zm-8.636,9.6L3.479,25.9V3.9l9.869,2.961V27.876Z"
                          transform="translate(-1.011 -1.006)"
                          fill="#A31D20"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
            </div>
            <div className="btn-container">
              <button onClick={toggleAudio}>
                <span className="pr-2">{muted ? 'Unmute' : 'Mute'}</span> <SvgIcon type={SvgType.MUTE} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: ${COLORS.darkBlue};
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;
  .outer-wrapper {
    width: 100%;
  }
  .container {
    width: 90%;
    margin: auto;
  }
  .title-container {
    margin: 20px 0px 10px 0px;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .nav-btns {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .btn-container {
    padding: 5px 5px;
    border-bottom: 1px solid #e2cfff;
    button {
      border: none;
      background: none;
      color: ${COLORS.glowBlue};
    }
  }
  .title {
    width: 70%;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
    color: black;
    margin: 0;
  }
  .back-button {
    font-size: 12px;
    color: ${COLORS.glowBlue};
    font-weight: bold;
  }
  .divider {
    background: #ffad2c;
    height: 2px;
    margin: 16px auto;
    width: 80%;
  }
  .tab-container {
    padding: 5px 0px 20px 0px;
    width: 95%;
    color: ${COLORS.glowBlue};
    border-bottom: solid 2px #e2cfff;
    margin: auto;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
    font-style: italic;
    p {
      margin-bottom: 0;
    }
    .active {
      color: #e50000;
    }
  }
  @media screen and (min-width: 540px) {
    .outer-wrapper {
      /* width: 700px; */
      margin: auto;
    }
  }
`

export default MobileMenu
